import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'

type Props = {
  assignments: {
    id: string
    workflow_assignee_id: string | null
  }[]
  companyId: string
}

export function useBulkUpdateOrderAssignee() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ assignments, companyId }: Props) => {
      const response = await axios.put(`assignments/workflow-status`, {
        assignments,
        company_id: companyId,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['workflow-log'])
    },
  })
}
